export type QueryValue =
  | string
  | number
  | boolean
  | ReadonlyArray<string>
  | null
  | undefined;

export function toQueryString(
  params: Readonly<Record<string, QueryValue>>
): string {
  const search = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined || value === '') {
      continue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        search.append(key, item);
      }
      continue;
    }

    search.append(key, String(value));
  }

  const query = search.toString();
  return query.length > 0 ? `?${query}` : '';
}
